<template>
  <div class="filters-watcher">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'FiltersWatcher',
    props: {
      filters: {
        type: Object,
        required: true,
      }
    },
    watch: {
      filters: {
        handler(value) { this.$emit('change', value) },
        deep: true,
      }
    }
  }
</script>